import service from '@/utils/request'

export function getWebViewConfig(config = {}) {
    return service.get('/api/v1/webViewConfig/', config)
}

export function getNotification(config = {}) {
    return service.get('/api/v1/notification/', config)
}

export function markAppDownloadLog() {
    return service.get('/api/v1/app-download-log/')
}

/** 优先到账活动：按活动日期窗口统计的邀请人数与档位状态 */
export function getPriorityArrivalStatus() {
    return service.get('/api/v1/priority-arrival/status/')
}
